<template>
  <div class="result" @click="gotoRecipe" :class="{'done': done && !favorite, 'favorite': favorite}" >
    <fa v-if="favorite" icon="star" />
    <fa v-else-if="done" icon="check" />
    <div class="image" :style="{ backgroundImage: `url(${imageUrl(recipe.ImageUrl)})` }"></div>
    <tags :list="getUniqueRecipeCategories(recipe.Categories)"/>
    <h6>{{recipe.Title}}</h6>
  </div>
</template>

<script>
import { functions } from '@/assets/script/functions'
import image from '@/helpers/imageHelper'
import recipe from '@/helpers/recipeHelper'
import tags from '@/components/common/Tags'

export default {
  props: ['recipe'],
  methods: {
    imageUrl(url){
      return image.imageUrl(url)
    },
    getUniqueRecipeCategories(categories){
      return functions.getUnique(categories, 'Name')
    },
    shortInstruction(instructions){
      return recipe.shortInstruction(instructions)
    },
    removeUnnecessaryIngredients(ingredients){
      return recipe.removeUnnecessaryIngredients(ingredients)
    },
    gotoRecipe(){
      this.$router.push({
        to: 'Recipe',
        path: '/opskrift/' + this.recipe.Url
      })
    }
  },
  computed: {
    done() {
      return this.recipe.Done || this.$store.getters.getRecipeDoneById(this.recipe.Id)
    },
    favorite() {
      return this.recipe.Favorite || this.$store.getters.getRecipeFavoriteById(this.recipe.Id)
    }
  },
  components: {
    tags
  }
}
</script>
